import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";

import { API_URL } from "../helpers";

import Hdg from "../components/Hdg";
import Alert from "../components/Alert";

import Invitation from "./Invitation";
import Registration from "./Registration";

const Guest = () => {
	const [details, setDetails] = useState({});
	const [alert, setAlert] = useState({
		type: "working",
		text: "",
	});

	const { str } = useParams();

	useEffect(() => {
		const init = async () => {
			const url = new URL(`${API_URL}/guestInit`);
			const params = {
				id: str ? str : "",
			};
			url.search = new URLSearchParams(params);

			try {
				const response = await fetch(url, {
					method: "GET",
					cache: "no-store",
				});
				const json = await response.json();
				if (json && (json.resp === 1 || json.resp === 2)) {
					setDetails({ ...json });
					setAlert({});
				} else {
					setAlert({
						type: "error",
						text: json.text,
					});
				}
			} catch (error) {
				setAlert({
					type: "error",
					text: "An error has occurred.",
				});
			}
		};

		init();

		// eslint-disable-next-line
	}, []);

	return (
		<>
			{alert.type === "working" ? (
				<Alert data={alert} />
			) : (
				<>
					<div id="left-column">
						<Hdg
							section={
								details.resp === 2 ? "Guest Registration" : "Guest Invitation"
							}
							home={true}
						/>

						{details.resp === 2 ? (
							<Registration details={details} />
						) : (
							<Invitation details={details} />
						)}

						<div className="spacer"></div>
					</div>

					<div id="right-column">
						<div
							className="blocktext"
							style={{ background: "#fff", border: "1px solid #ddd" }}
						>
							<div
								className="logo"
								style={{ margin: "0 auto 25px auto", display: "block" }}
							>
								<img
									src="https://vto.qnmcdn.com/assets/img/benefit-for-children-logo.png"
									alt="BFC"
									style={{ width: "35%", display: "block", margin: "0px auto" }}
								/>
							</div>
							<p>
								The 2027 Valero Benefit for Children, the Valero Energy
								Foundation’s annual charitable fundraiser focusing on children
								in need, returns for its 18th year to the magnificent JW
								Marriott San Antonio Hill Country Resort & Spa and TPC San
								Antonio.
							</p>

							<p style={{ marginBottom: "0" }}>
								The excitement begins on Sunday, April 4 with our extraordinary
								Welcome Party immediately following the conclusion of the Valero
								Texas Open, then continues on Monday, April 5 with golf outings
								in and around San Antonio, and sporting clays tournaments.
							</p>
						</div>
					</div>
				</>
			)}
		</>
	);
};

export default Guest;
